export default "__VITE_ASSET__Cj6xzc8M__"